import { render, staticRenderFns } from "./configMainPage.vue?vue&type=template&id=784e87e2&"
import script from "./configMainPage.vue?vue&type=script&lang=js&"
export * from "./configMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports